<template>
  <div class="booking">
    <h1 v-if="!isLoading && !isSent">Online booking</h1>
    <p v-if="!isLoading && !isSent">Send an inquiry and we will contact you.</p>
    <form class="booking-form" v-if="!isLoading && !isSent">
      <input :class="{ 'invalid': firstSubmit && !this.request.name.length }" type="text" v-model="request.name" required placeholder="First name">
      <input :class="{ 'invalid': firstSubmit && !this.request.family.length }" type="text" v-model="request.family" required placeholder="Last name">
      <input :class="{ 'invalid': firstSubmit && !this.request.email.length }" type="email" v-model="request.email" required placeholder="E-mail">
      <input :class="{ 'invalid': firstSubmit && !this.request.phone.length }" type="text" v-model="request.phone" required placeholder="Phone">
      <input
        :class="{ 'invalid': firstSubmit && !this.request.passengers.length }"
        type="number"
        v-model="request.passengers"
        required
        placeholder="How many passengers"
      >
      <textarea :class="{ 'invalid': firstSubmit && !this.request.info.length }" v-model="request.info" placeholder="Destination/Other information"></textarea>
      <button class="submit" @click.prevent="send()">Book now</button>
    </form>
    <img v-if="isLoading && !isSent && !isFailed" src="../assets/img/loading.svg" alt>
    <h1 class="thanks" v-if="isSent">Thank you!</h1>
    <p v-if="isSent">We will contact you very soon.</p>
    <h1 class="thanks failed" v-if="isFailed">Something went wrong!</h1>
    <p class="failed" v-if="isFailed">Please try again later.</p>
  </div>
</template>

<script>
import Email from "../assets/js/smtp.js";
export default {
  data() {
    return {
      isLoading: false,
      isSent: false,
      isFailed: false,
      firstSubmit: false,
      request: {
        name: "",
        family: "",
        email: "",
        phone: "",
        passengers: "",
        info: ""
      }
    };
  },
  methods: {
    isValid() {
      if (!this.request.name.length) {
        return false;
      }
      if (!this.request.family.length) {
        return false;
      }
      if (!this.request.email.length) {
        return false;
      }
      if (!this.request.phone.length) {
        return false;
      }
      if (!this.request.passengers.length) {
        return false;
      }
      if (!this.request.info.length) {
        return false;
      }
      return true;
    },
    send() {
      if (!this.firstSubmit) {
        this.firstSubmit = true;
      }
      if (this.isValid()) {
        this.isLoading = true;
        this.isFailed = false;
        Email.send({
          // SecureToken: "4ff79846-3580-4654-bd81-b38f0bb6b8d2",
          Host: "mail.alexcyprustaxi.com",
          Username: "alex@alexcyprustaxi.com",
          Password: "zxKFB8ra_7]K",
          To: "alextaxicyprus@gmail.com",
          From: "alex@alexcyprustaxi.com",
          Subject: "Taxi booking",
          Body: `
          Hello,<br><br>
          You have a new booking inquiry:<br><br>

          <strong>First name:</strong> ${this.request.name},<br>
          <strong>Last name:</strong> ${this.request.family},<br>
          <strong>E-mail:</strong> ${this.request.email},<br>
          <strong>Phone:</strong> ${this.request.phone},<br>
          <strong>How many passengers:</strong> ${this.request.passengers},<br>
          <strong>More information:</strong> ${this.request.info},<br><br>

          This is an automatic email. Please don't reply to it.
          `
        }).then(message => {
          if (message == "OK") {
            this.isLoading = false;
            this.isSent = true;
            this.request = {
              name: "",
              family: "",
              email: "",
              phone: "",
              passengers: "",
              info: ""
            };
          } else {
            this.isFailed = true;
          }
          console.log(message);
        });
      }
    }
  }
};
</script>

<style>
.booking {
  align-items: center;
  background-color: #f3f3f3;
  background-image: url("../assets/img/cover_blur.jpg");
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  padding: 20px;
  width: 100%;
}
.booking h1,
.booking p {
  color: #fff;
  text-align: center;
  width: 100%;
}
.booking p {
  margin: 10px 0;
}
.booking a {
  white-space: nowrap;
}
.booking-form {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  max-width: 500px;
  width: 100%;
}
.booking input,
.booking textarea {
  background-color: #fff;
  border: 2px solid #fff;
  border-radius: 6px;
  height: 50px;
  margin-bottom: 10px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 100%;
}
.booking textarea {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  height: 100px;
  padding: 15px;
  resize: none;
}
.submit {
  align-items: center;
  background-color: #fdd55b;
  border: none;
  border-radius: 6px;
  display: flex;
  height: 50px;
  justify-content: center;
  margin: 10px auto 0;
  width: 260px;
}
.submit:hover {
  opacity: 0.9;
}
.thanks {
  margin: 0;
}
.invalid {
  border: 2px solid #f44842 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Booking.vue